export interface Translations {
  tabRoll: string;
  tabHistory: string;
  tabSettings: string;
  headerRoll: string;
  headerHistory: string;
  headerSettings: string;
  sumLabel: string;
  rollBtn: string;
  rollBtnAria: string;
  clearHistory: string;
  historyEmpty: string;
  historyEmptyHint: string;
  historyRollTitle: string;
  timeJustNow: string;
  /** Use %n as placeholder for the number */
  timeMinAgo: string;
  /** Use %n as placeholder for the number */
  timeHourAgo: string;
  /** Use %n as placeholder for the number */
  timeDayAgo: string;
  settingsDiceType: string;
  settingsCount: string;
  settingsRollBtn: string;
  settingsLanguage: string;
}

/** Replace %n placeholder with an actual number */
export function tn(template: string, n: number): string {
  return template.replace('%n', String(n));
}

export const TRANSLATIONS: Record<string, Translations> = {
  zh: {
    tabRoll: '投骰',
    tabHistory: '历史',
    tabSettings: '设置',
    headerRoll: '投骰子',
    headerHistory: '投骰历史',
    headerSettings: '投骰设置',
    sumLabel: '总计：',
    rollBtn: '投骰',
    rollBtnAria: '重新投骰',
    clearHistory: '清除历史',
    historyEmpty: '暂无历史',
    historyEmptyHint: '投掷骰子后，结果将显示在这里',
    historyRollTitle: '投掷',
    timeJustNow: '刚刚',
    timeMinAgo: '%n 分钟前',
    timeHourAgo: '%n 小时前',
    timeDayAgo: '%n 天前',
    settingsDiceType: '骰子类型',
    settingsCount: '骰子数量',
    settingsRollBtn: '投骰子 🎲',
    settingsLanguage: '语言',
  },

  es: {
    tabRoll: 'Tirar',
    tabHistory: 'Historial',
    tabSettings: 'Ajustes',
    headerRoll: 'Tirada de dados',
    headerHistory: 'Historial de tiradas',
    headerSettings: 'Ajustes de tirada',
    sumLabel: 'Total:',
    rollBtn: 'Tirar',
    rollBtnAria: 'Tirar de nuevo',
    clearHistory: 'Limpiar historial',
    historyEmpty: 'El historial está vacío',
    historyEmptyHint: 'Lanza los dados — los resultados aparecerán aquí',
    historyRollTitle: 'Tirada',
    timeJustNow: 'ahora mismo',
    timeMinAgo: 'hace %n min',
    timeHourAgo: 'hace %n h',
    timeDayAgo: 'hace %n d',
    settingsDiceType: 'Tipo de dado',
    settingsCount: 'Cantidad de dados',
    settingsRollBtn: 'Tirar dados 🎲',
    settingsLanguage: 'Idioma',
  },

  en: {
    tabRoll: 'Roll',
    tabHistory: 'History',
    tabSettings: 'Settings',
    headerRoll: 'Dice Roll',
    headerHistory: 'Roll History',
    headerSettings: 'Roll Settings',
    sumLabel: 'Total:',
    rollBtn: 'Roll',
    rollBtnAria: 'Roll again',
    clearHistory: 'Clear history',
    historyEmpty: 'History is empty',
    historyEmptyHint: 'Roll the dice — results will appear here',
    historyRollTitle: 'Roll',
    timeJustNow: 'just now',
    timeMinAgo: '%n min ago',
    timeHourAgo: '%n hr ago',
    timeDayAgo: '%n d ago',
    settingsDiceType: 'Dice type',
    settingsCount: 'Number of dice',
    settingsRollBtn: 'Roll dice 🎲',
    settingsLanguage: 'Language',
  },

  hi: {
    tabRoll: 'रोल',
    tabHistory: 'इतिहास',
    tabSettings: 'सेटिंग',
    headerRoll: 'पासा रोल',
    headerHistory: 'रोल इतिहास',
    headerSettings: 'रोल सेटिंग',
    sumLabel: 'कुल:',
    rollBtn: 'रोल',
    rollBtnAria: 'फिर से रोल करें',
    clearHistory: 'इतिहास साफ़ करें',
    historyEmpty: 'इतिहास खाली है',
    historyEmptyHint: 'पासे फेंकें — परिणाम यहाँ दिखाई देंगे',
    historyRollTitle: 'रोल',
    timeJustNow: 'अभी',
    timeMinAgo: '%n मिनट पहले',
    timeHourAgo: '%n घंटे पहले',
    timeDayAgo: '%n दिन पहले',
    settingsDiceType: 'पासे का प्रकार',
    settingsCount: 'पासों की संख्या',
    settingsRollBtn: 'पासा फेंकें 🎲',
    settingsLanguage: 'भाषा',
  },

  bn: {
    tabRoll: 'রোল',
    tabHistory: 'ইতিহাস',
    tabSettings: 'সেটিং',
    headerRoll: 'পাশা রোল',
    headerHistory: 'রোল ইতিহাস',
    headerSettings: 'রোল সেটিং',
    sumLabel: 'মোট:',
    rollBtn: 'রোল',
    rollBtnAria: 'আবার রোল করুন',
    clearHistory: 'ইতিহাস মুছুন',
    historyEmpty: 'ইতিহাস খালি',
    historyEmptyHint: 'পাশা ফেলুন — ফলাফল এখানে দেখাবে',
    historyRollTitle: 'রোল',
    timeJustNow: 'এইমাত্র',
    timeMinAgo: '%n মিনিট আগে',
    timeHourAgo: '%n ঘণ্টা আগে',
    timeDayAgo: '%n দিন আগে',
    settingsDiceType: 'পাশার ধরন',
    settingsCount: 'পাশার সংখ্যা',
    settingsRollBtn: 'পাশা ফেলুন 🎲',
    settingsLanguage: 'ভাষা',
  },

  pt: {
    tabRoll: 'Rolar',
    tabHistory: 'Histórico',
    tabSettings: 'Configurações',
    headerRoll: 'Rolar dados',
    headerHistory: 'Histórico de rolagens',
    headerSettings: 'Config. de rolagem',
    sumLabel: 'Total:',
    rollBtn: 'Rolar',
    rollBtnAria: 'Rolar novamente',
    clearHistory: 'Limpar histórico',
    historyEmpty: 'Histórico vazio',
    historyEmptyHint: 'Role os dados — os resultados aparecerão aqui',
    historyRollTitle: 'Rolagem',
    timeJustNow: 'agora mesmo',
    timeMinAgo: 'há %n min',
    timeHourAgo: 'há %n h',
    timeDayAgo: 'há %n d',
    settingsDiceType: 'Tipo de dado',
    settingsCount: 'Quantidade de dados',
    settingsRollBtn: 'Rolar dados 🎲',
    settingsLanguage: 'Idioma',
  },

  ru: {
    tabRoll: 'Бросок',
    tabHistory: 'История',
    tabSettings: 'Настройки',
    headerRoll: 'Бросок кубиков',
    headerHistory: 'История бросков',
    headerSettings: 'Настройки броска',
    sumLabel: 'Сумма:',
    rollBtn: 'Бросить',
    rollBtnAria: 'Бросить снова',
    clearHistory: 'Очистить историю',
    historyEmpty: 'История пуста',
    historyEmptyHint: 'Бросайте кубики — результаты появятся здесь',
    historyRollTitle: 'Бросок',
    timeJustNow: 'только что',
    timeMinAgo: '%n мин. назад',
    timeHourAgo: '%n ч. назад',
    timeDayAgo: '%n д. назад',
    settingsDiceType: 'Тип кубика',
    settingsCount: 'Количество кубиков',
    settingsRollBtn: 'Бросить кубики 🎲',
    settingsLanguage: 'Язык',
  },

  ja: {
    tabRoll: 'ロール',
    tabHistory: '履歴',
    tabSettings: '設定',
    headerRoll: 'サイコロを振る',
    headerHistory: '振り履歴',
    headerSettings: '振り設定',
    sumLabel: '合計：',
    rollBtn: '振る',
    rollBtnAria: 'もう一度振る',
    clearHistory: '履歴を消去',
    historyEmpty: '履歴がありません',
    historyEmptyHint: 'サイコロを振ると結果がここに表示されます',
    historyRollTitle: '振り',
    timeJustNow: 'たった今',
    timeMinAgo: '%n 分前',
    timeHourAgo: '%n 時間前',
    timeDayAgo: '%n 日前',
    settingsDiceType: 'サイコロの種類',
    settingsCount: 'サイコロの個数',
    settingsRollBtn: 'サイコロを振る 🎲',
    settingsLanguage: '言語',
  },

  ar: {
    tabRoll: 'رمي',
    tabHistory: 'السجل',
    tabSettings: 'الإعدادات',
    headerRoll: 'رمي النرد',
    headerHistory: 'سجل الرمي',
    headerSettings: 'إعدادات الرمي',
    sumLabel: 'المجموع:',
    rollBtn: 'رمي',
    rollBtnAria: 'رمي مرة أخرى',
    clearHistory: 'مسح السجل',
    historyEmpty: 'السجل فارغ',
    historyEmptyHint: 'ارمِ النرد — ستظهر النتائج هنا',
    historyRollTitle: 'رمية',
    timeJustNow: 'الآن',
    timeMinAgo: 'منذ %n دقيقة',
    timeHourAgo: 'منذ %n ساعة',
    timeDayAgo: 'منذ %n يوم',
    settingsDiceType: 'نوع النرد',
    settingsCount: 'عدد النرد',
    settingsRollBtn: 'رمي النرد 🎲',
    settingsLanguage: 'اللغة',
  },

  pa: {
    tabRoll: 'ਰੋਲ',
    tabHistory: 'ਇਤਿਹਾਸ',
    tabSettings: 'ਸੈਟਿੰਗ',
    headerRoll: 'ਪਾਸਾ ਰੋਲ',
    headerHistory: 'ਰੋਲ ਇਤਿਹਾਸ',
    headerSettings: 'ਰੋਲ ਸੈਟਿੰਗ',
    sumLabel: 'ਕੁੱਲ:',
    rollBtn: 'ਰੋਲ',
    rollBtnAria: 'ਦੁਬਾਰਾ ਰੋਲ ਕਰੋ',
    clearHistory: 'ਇਤਿਹਾਸ ਸਾਫ਼ ਕਰੋ',
    historyEmpty: 'ਇਤਿਹਾਸ ਖਾਲੀ ਹੈ',
    historyEmptyHint: 'ਪਾਸਾ ਸੁੱਟੋ — ਨਤੀਜੇ ਇੱਥੇ ਦਿਖਾਈ ਦੇਣਗੇ',
    historyRollTitle: 'ਰੋਲ',
    timeJustNow: 'ਹੁਣੇ',
    timeMinAgo: '%n ਮਿੰਟ ਪਹਿਲਾਂ',
    timeHourAgo: '%n ਘੰਟੇ ਪਹਿਲਾਂ',
    timeDayAgo: '%n ਦਿਨ ਪਹਿਲਾਂ',
    settingsDiceType: 'ਪਾਸੇ ਦੀ ਕਿਸਮ',
    settingsCount: 'ਪਾਸਿਆਂ ਦੀ ਗਿਣਤੀ',
    settingsRollBtn: 'ਪਾਸਾ ਸੁੱਟੋ 🎲',
    settingsLanguage: 'ਭਾਸ਼ਾ',
  },

  mr: {
    tabRoll: 'रोल',
    tabHistory: 'इतिहास',
    tabSettings: 'सेटिंग',
    headerRoll: 'फासे रोल',
    headerHistory: 'रोल इतिहास',
    headerSettings: 'रोल सेटिंग',
    sumLabel: 'एकूण:',
    rollBtn: 'रोल',
    rollBtnAria: 'पुन्हा रोल करा',
    clearHistory: 'इतिहास साफ करा',
    historyEmpty: 'इतिहास रिकामा आहे',
    historyEmptyHint: 'फासे टाका — निकाल येथे दिसतील',
    historyRollTitle: 'रोल',
    timeJustNow: 'आत्ता',
    timeMinAgo: '%n मिनिटांपूर्वी',
    timeHourAgo: '%n तासांपूर्वी',
    timeDayAgo: '%n दिवसांपूर्वी',
    settingsDiceType: 'फाशाचा प्रकार',
    settingsCount: 'फाशांची संख्या',
    settingsRollBtn: 'फासे टाका 🎲',
    settingsLanguage: 'भाषा',
  },

  te: {
    tabRoll: 'రోల్',
    tabHistory: 'చరిత్ర',
    tabSettings: 'సెటింగ్‌లు',
    headerRoll: 'పాచికలు రోల్',
    headerHistory: 'రోల్ చరిత్ర',
    headerSettings: 'రోల్ సెటింగ్‌లు',
    sumLabel: 'మొత్తం:',
    rollBtn: 'రోల్',
    rollBtnAria: 'మళ్ళీ రోల్ చేయండి',
    clearHistory: 'చరిత్ర తొలగించు',
    historyEmpty: 'చరిత్ర ఖాళీగా ఉంది',
    historyEmptyHint: 'పాచికలు వేయండి — ఫలితాలు ఇక్కడ కనిపిస్తాయి',
    historyRollTitle: 'రోల్',
    timeJustNow: 'ఇప్పుడే',
    timeMinAgo: '%n నిమిషాల క్రితం',
    timeHourAgo: '%n గంటల క్రితం',
    timeDayAgo: '%n రోజుల క్రితం',
    settingsDiceType: 'పాచిక రకం',
    settingsCount: 'పాచికల సంఖ్య',
    settingsRollBtn: 'పాచికలు వేయండి 🎲',
    settingsLanguage: 'భాష',
  },

  vi: {
    tabRoll: 'Tung',
    tabHistory: 'Lịch sử',
    tabSettings: 'Cài đặt',
    headerRoll: 'Tung xúc xắc',
    headerHistory: 'Lịch sử tung',
    headerSettings: 'Cài đặt tung',
    sumLabel: 'Tổng:',
    rollBtn: 'Tung',
    rollBtnAria: 'Tung lại',
    clearHistory: 'Xóa lịch sử',
    historyEmpty: 'Lịch sử trống',
    historyEmptyHint: 'Tung xúc xắc — kết quả sẽ hiển thị ở đây',
    historyRollTitle: 'Lần tung',
    timeJustNow: 'vừa xong',
    timeMinAgo: '%n phút trước',
    timeHourAgo: '%n giờ trước',
    timeDayAgo: '%n ngày trước',
    settingsDiceType: 'Loại xúc xắc',
    settingsCount: 'Số lượng xúc xắc',
    settingsRollBtn: 'Tung xúc xắc 🎲',
    settingsLanguage: 'Ngôn ngữ',
  },

  tr: {
    tabRoll: 'At',
    tabHistory: 'Geçmiş',
    tabSettings: 'Ayarlar',
    headerRoll: 'Zar Atışı',
    headerHistory: 'Atış Geçmişi',
    headerSettings: 'Atış Ayarları',
    sumLabel: 'Toplam:',
    rollBtn: 'At',
    rollBtnAria: 'Tekrar at',
    clearHistory: 'Geçmişi temizle',
    historyEmpty: 'Geçmiş boş',
    historyEmptyHint: 'Zarları at — sonuçlar burada görünecek',
    historyRollTitle: 'Atış',
    timeJustNow: 'az önce',
    timeMinAgo: '%n dk önce',
    timeHourAgo: '%n sa önce',
    timeDayAgo: '%n g önce',
    settingsDiceType: 'Zar türü',
    settingsCount: 'Zar adedi',
    settingsRollBtn: 'Zar at 🎲',
    settingsLanguage: 'Dil',
  },

  ta: {
    tabRoll: 'உருட்டு',
    tabHistory: 'வரலாறு',
    tabSettings: 'அமைப்புகள்',
    headerRoll: 'பகடை உருட்டல்',
    headerHistory: 'உருட்டல் வரலாறு',
    headerSettings: 'உருட்டல் அமைப்புகள்',
    sumLabel: 'மொத்தம்:',
    rollBtn: 'உருட்டு',
    rollBtnAria: 'மீண்டும் உருட்டு',
    clearHistory: 'வரலாற்றை அழி',
    historyEmpty: 'வரலாறு காலியாக உள்ளது',
    historyEmptyHint: 'பகடை உருட்டுங்கள் — முடிவுகள் இங்கே தோன்றும்',
    historyRollTitle: 'உருட்டல்',
    timeJustNow: 'இப்போதே',
    timeMinAgo: '%n நிமிடம் முன்பு',
    timeHourAgo: '%n மணி முன்பு',
    timeDayAgo: '%n நாள் முன்பு',
    settingsDiceType: 'பகடை வகை',
    settingsCount: 'பகடை எண்ணிக்கை',
    settingsRollBtn: 'பகடை உருட்டு 🎲',
    settingsLanguage: 'மொழி',
  },

  ko: {
    tabRoll: '굴리기',
    tabHistory: '기록',
    tabSettings: '설정',
    headerRoll: '주사위 굴리기',
    headerHistory: '굴리기 기록',
    headerSettings: '굴리기 설정',
    sumLabel: '합계:',
    rollBtn: '굴려',
    rollBtnAria: '다시 굴리기',
    clearHistory: '기록 지우기',
    historyEmpty: '기록이 없습니다',
    historyEmptyHint: '주사위를 굴리면 결과가 여기에 표시됩니다',
    historyRollTitle: '굴리기',
    timeJustNow: '방금',
    timeMinAgo: '%n분 전',
    timeHourAgo: '%n시간 전',
    timeDayAgo: '%n일 전',
    settingsDiceType: '주사위 종류',
    settingsCount: '주사위 개수',
    settingsRollBtn: '주사위 굴리기 🎲',
    settingsLanguage: '언어',
  },

  fr: {
    tabRoll: 'Lancer',
    tabHistory: 'Historique',
    tabSettings: 'Paramètres',
    headerRoll: 'Lancer de dés',
    headerHistory: 'Historique des lancers',
    headerSettings: 'Paramètres de lancer',
    sumLabel: 'Total :',
    rollBtn: 'Lancer',
    rollBtnAria: 'Relancer',
    clearHistory: "Effacer l'historique",
    historyEmpty: "L'historique est vide",
    historyEmptyHint: 'Lancez les dés — les résultats apparaîtront ici',
    historyRollTitle: 'Lancer',
    timeJustNow: "à l'instant",
    timeMinAgo: 'il y a %n min',
    timeHourAgo: 'il y a %n h',
    timeDayAgo: 'il y a %n j',
    settingsDiceType: 'Type de dé',
    settingsCount: 'Nombre de dés',
    settingsRollBtn: 'Lancer les dés 🎲',
    settingsLanguage: 'Langue',
  },

  de: {
    tabRoll: 'Würfeln',
    tabHistory: 'Verlauf',
    tabSettings: 'Einstellungen',
    headerRoll: 'Würfelwurf',
    headerHistory: 'Wurf-Verlauf',
    headerSettings: 'Wurf-Einstellungen',
    sumLabel: 'Summe:',
    rollBtn: 'Würfeln',
    rollBtnAria: 'Erneut würfeln',
    clearHistory: 'Verlauf löschen',
    historyEmpty: 'Verlauf ist leer',
    historyEmptyHint: 'Würfeln Sie — Ergebnisse erscheinen hier',
    historyRollTitle: 'Wurf',
    timeJustNow: 'gerade eben',
    timeMinAgo: 'vor %n Min.',
    timeHourAgo: 'vor %n Std.',
    timeDayAgo: 'vor %n T.',
    settingsDiceType: 'Würfeltyp',
    settingsCount: 'Würfelanzahl',
    settingsRollBtn: 'Würfeln 🎲',
    settingsLanguage: 'Sprache',
  },

  ur: {
    tabRoll: 'رول',
    tabHistory: 'تاریخ',
    tabSettings: 'ترتیبات',
    headerRoll: 'پانسہ رول',
    headerHistory: 'رول تاریخ',
    headerSettings: 'رول ترتیبات',
    sumLabel: 'مجموع:',
    rollBtn: 'رول',
    rollBtnAria: 'دوبارہ رول کریں',
    clearHistory: 'تاریخ صاف کریں',
    historyEmpty: 'تاریخ خالی ہے',
    historyEmptyHint: 'پانسہ پھینکیں — نتائج یہاں ظاہر ہوں گے',
    historyRollTitle: 'رول',
    timeJustNow: 'ابھی',
    timeMinAgo: '%n منٹ پہلے',
    timeHourAgo: '%n گھنٹے پہلے',
    timeDayAgo: '%n دن پہلے',
    settingsDiceType: 'پانسے کی قسم',
    settingsCount: 'پانسوں کی تعداد',
    settingsRollBtn: 'پانسہ پھینکیں 🎲',
    settingsLanguage: 'زبان',
  },

  jv: {
    tabRoll: 'Gulung',
    tabHistory: 'Riwayat',
    tabSettings: 'Setelan',
    headerRoll: 'Gulung Dadu',
    headerHistory: 'Riwayat Gulung',
    headerSettings: 'Setelan Gulung',
    sumLabel: 'Total:',
    rollBtn: 'Gulung',
    rollBtnAria: 'Gulung maneh',
    clearHistory: 'Resiki riwayat',
    historyEmpty: 'Riwayat kosong',
    historyEmptyHint: 'Gulung dadu — asil bakal katon ing kene',
    historyRollTitle: 'Gulung',
    timeJustNow: 'mau',
    timeMinAgo: '%n menit kepungkur',
    timeHourAgo: '%n jam kepungkur',
    timeDayAgo: '%n dina kepungkur',
    settingsDiceType: 'Jinis dadu',
    settingsCount: 'Jumlah dadu',
    settingsRollBtn: 'Gulung dadu 🎲',
    settingsLanguage: 'Basa',
  },

  it: {
    tabRoll: 'Lancia',
    tabHistory: 'Cronologia',
    tabSettings: 'Impostazioni',
    headerRoll: 'Lancio dei dadi',
    headerHistory: 'Cronologia lanci',
    headerSettings: 'Impostazioni lanci',
    sumLabel: 'Totale:',
    rollBtn: 'Lancia',
    rollBtnAria: 'Lancia di nuovo',
    clearHistory: 'Cancella cronologia',
    historyEmpty: 'La cronologia è vuota',
    historyEmptyHint: 'Lancia i dadi — i risultati appariranno qui',
    historyRollTitle: 'Lancio',
    timeJustNow: 'ora',
    timeMinAgo: '%n min fa',
    timeHourAgo: '%n h fa',
    timeDayAgo: '%n g fa',
    settingsDiceType: 'Tipo di dado',
    settingsCount: 'Quantità di dadi',
    settingsRollBtn: 'Lancia i dadi 🎲',
    settingsLanguage: 'Lingua',
  },

  fa: {
    tabRoll: 'پرتاب',
    tabHistory: 'تاریخچه',
    tabSettings: 'تنظیمات',
    headerRoll: 'پرتاب تاس',
    headerHistory: 'تاریخچه پرتاب',
    headerSettings: 'تنظیمات پرتاب',
    sumLabel: 'مجموع:',
    rollBtn: 'پرتاب',
    rollBtnAria: 'دوباره پرتاب کن',
    clearHistory: 'پاک کردن تاریخچه',
    historyEmpty: 'تاریخچه خالی است',
    historyEmptyHint: 'تاس بیندازید — نتایج اینجا نمایش داده می‌شوند',
    historyRollTitle: 'پرتاب',
    timeJustNow: 'همین الان',
    timeMinAgo: '%n دقیقه پیش',
    timeHourAgo: '%n ساعت پیش',
    timeDayAgo: '%n روز پیش',
    settingsDiceType: 'نوع تاس',
    settingsCount: 'تعداد تاس',
    settingsRollBtn: 'پرتاب تاس 🎲',
    settingsLanguage: 'زبان',
  },

  gu: {
    tabRoll: 'રોલ',
    tabHistory: 'ઇતિહાસ',
    tabSettings: 'સેટિંગ',
    headerRoll: 'પાસા રોલ',
    headerHistory: 'રોલ ઇતિહાસ',
    headerSettings: 'રોલ સેટિંગ',
    sumLabel: 'કુલ:',
    rollBtn: 'રોલ',
    rollBtnAria: 'ફરીથી રોલ કરો',
    clearHistory: 'ઇતિહાસ સાફ કરો',
    historyEmpty: 'ઇતિહાસ ખાલી છે',
    historyEmptyHint: 'પાસા ફેંકો — પરિણામ અહીં દેખાશે',
    historyRollTitle: 'રોલ',
    timeJustNow: 'હમણાં',
    timeMinAgo: '%n મિનિટ પહેલાં',
    timeHourAgo: '%n કલાક પહેલાં',
    timeDayAgo: '%n દિવસ પહેલાં',
    settingsDiceType: 'પાસાનો પ્રકાર',
    settingsCount: 'પાસાઓની સંખ્યા',
    settingsRollBtn: 'પાસા ફેંકો 🎲',
    settingsLanguage: 'ભાષા',
  },

  kn: {
    tabRoll: 'ರೋಲ್',
    tabHistory: 'ಇತಿಹಾಸ',
    tabSettings: 'ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
    headerRoll: 'ದಾಳ ರೋಲ್',
    headerHistory: 'ರೋಲ್ ಇತಿಹಾಸ',
    headerSettings: 'ರೋಲ್ ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
    sumLabel: 'ಒಟ್ಟು:',
    rollBtn: 'ರೋಲ್',
    rollBtnAria: 'ಮತ್ತೆ ರೋಲ್ ಮಾಡಿ',
    clearHistory: 'ಇತಿಹಾಸ ತೆರವು',
    historyEmpty: 'ಇತಿಹಾಸ ಖಾಲಿ',
    historyEmptyHint: 'ದಾಳ ಹಾಕಿ — ಫಲಿತಾಂಶಗಳು ಇಲ್ಲಿ ಕಾಣಿಸುತ್ತವೆ',
    historyRollTitle: 'ರೋಲ್',
    timeJustNow: 'ಈಗಷ್ಟೇ',
    timeMinAgo: '%n ನಿಮಿಷ ಹಿಂದೆ',
    timeHourAgo: '%n ಗಂಟೆ ಹಿಂದೆ',
    timeDayAgo: '%n ದಿನ ಹಿಂದೆ',
    settingsDiceType: 'ದಾಳ ಪ್ರಕಾರ',
    settingsCount: 'ದಾಳಗಳ ಸಂಖ್ಯೆ',
    settingsRollBtn: 'ದಾಳ ಹಾಕಿ 🎲',
    settingsLanguage: 'ಭಾಷೆ',
  },

  ha: {
    tabRoll: 'Jefa',
    tabHistory: 'Tarihi',
    tabSettings: 'Saiti',
    headerRoll: 'Jefa Kwallon',
    headerHistory: 'Tarihin Jefa',
    headerSettings: 'Saiti na Jefa',
    sumLabel: 'Jimla:',
    rollBtn: 'Jefa',
    rollBtnAria: 'Jefa kuma',
    clearHistory: 'Share tarihi',
    historyEmpty: 'Tarihi a fanko',
    historyEmptyHint: 'Jefa kwallon — sakamakon zai bayyana nan',
    historyRollTitle: 'Jefa',
    timeJustNow: 'yanzu',
    timeMinAgo: 'minti %n da suka wuce',
    timeHourAgo: "sa'a %n da suka wuce",
    timeDayAgo: 'kwana %n da suka wuce',
    settingsDiceType: 'Irin kwallon',
    settingsCount: 'Yawan kwallaye',
    settingsRollBtn: 'Jefa kwallon 🎲',
    settingsLanguage: 'Harshe',
  },

  id: {
    tabRoll: 'Lempar',
    tabHistory: 'Riwayat',
    tabSettings: 'Pengaturan',
    headerRoll: 'Lempar Dadu',
    headerHistory: 'Riwayat Lempar',
    headerSettings: 'Pengaturan Lempar',
    sumLabel: 'Total:',
    rollBtn: 'Lempar',
    rollBtnAria: 'Lempar lagi',
    clearHistory: 'Hapus riwayat',
    historyEmpty: 'Riwayat kosong',
    historyEmptyHint: 'Lempar dadu — hasilnya akan muncul di sini',
    historyRollTitle: 'Lemparan',
    timeJustNow: 'baru saja',
    timeMinAgo: '%n menit lalu',
    timeHourAgo: '%n jam lalu',
    timeDayAgo: '%n hari lalu',
    settingsDiceType: 'Jenis dadu',
    settingsCount: 'Jumlah dadu',
    settingsRollBtn: 'Lempar dadu 🎲',
    settingsLanguage: 'Bahasa',
  },

  yo: {
    tabRoll: 'Sọ',
    tabHistory: 'Ìtàn',
    tabSettings: 'Ètò',
    headerRoll: 'Sọ Ìdì',
    headerHistory: 'Ìtàn Sọ',
    headerSettings: 'Ètò Sọ',
    sumLabel: 'Àpapọ̀:',
    rollBtn: 'Sọ',
    rollBtnAria: 'Sọ lẹ́ẹ̀kan sí',
    clearHistory: 'Pa ìtàn rẹ',
    historyEmpty: 'Ìtàn òfo',
    historyEmptyHint: 'Sọ ìdì — àwọn èsì yóò farahàn níbí',
    historyRollTitle: 'Sọ',
    timeJustNow: 'ìsinsìnyí',
    timeMinAgo: 'ìṣẹ́jú %n sẹ́yìn',
    timeHourAgo: 'wákàtí %n sẹ́yìn',
    timeDayAgo: 'ọjọ́ %n sẹ́yìn',
    settingsDiceType: 'Irú ìdì',
    settingsCount: 'Iye ìdì',
    settingsRollBtn: 'Sọ ìdì 🎲',
    settingsLanguage: 'Èdè',
  },

  pl: {
    tabRoll: 'Rzut',
    tabHistory: 'Historia',
    tabSettings: 'Ustawienia',
    headerRoll: 'Rzut kostką',
    headerHistory: 'Historia rzutów',
    headerSettings: 'Ustawienia rzutu',
    sumLabel: 'Suma:',
    rollBtn: 'Rzuć',
    rollBtnAria: 'Rzuć ponownie',
    clearHistory: 'Wyczyść historię',
    historyEmpty: 'Historia jest pusta',
    historyEmptyHint: 'Rzuć kostką — wyniki pojawią się tutaj',
    historyRollTitle: 'Rzut',
    timeJustNow: 'przed chwilą',
    timeMinAgo: '%n min temu',
    timeHourAgo: '%n godz. temu',
    timeDayAgo: '%n dni temu',
    settingsDiceType: 'Typ kostki',
    settingsCount: 'Liczba kości',
    settingsRollBtn: 'Rzuć kostką 🎲',
    settingsLanguage: 'Język',
  },

  uz: {
    tabRoll: 'Tashlash',
    tabHistory: 'Tarix',
    tabSettings: 'Sozlamalar',
    headerRoll: 'Zar tashlash',
    headerHistory: 'Tashlash tarixi',
    headerSettings: 'Tashlash sozlamalari',
    sumLabel: 'Jami:',
    rollBtn: 'Tashlash',
    rollBtnAria: 'Qayta tashlash',
    clearHistory: 'Tarixni tozalash',
    historyEmpty: "Tarix bo'sh",
    historyEmptyHint: "Zar tashlang — natijalar shu yerda ko'rinadi",
    historyRollTitle: 'Tashlash',
    timeJustNow: 'hozir',
    timeMinAgo: '%n daqiqa oldin',
    timeHourAgo: '%n soat oldin',
    timeDayAgo: '%n kun oldin',
    settingsDiceType: 'Zar turi',
    settingsCount: 'Zarlar soni',
    settingsRollBtn: 'Zar tashlash 🎲',
    settingsLanguage: 'Til',
  },

  my: {
    tabRoll: 'လှိမ့်',
    tabHistory: 'သမိုင်း',
    tabSettings: 'ဆက်တင်',
    headerRoll: 'အန်သေးလှိမ့်ခြင်း',
    headerHistory: 'လှိမ့်ခြင်း သမိုင်း',
    headerSettings: 'လှိမ့်ခြင်း ဆက်တင်',
    sumLabel: 'စုစုပေါင်း:',
    rollBtn: 'လှိမ့်',
    rollBtnAria: 'ထပ်မံလှိမ့်',
    clearHistory: 'သမိုင်းရှင်းရန်',
    historyEmpty: 'သမိုင်းမရှိ',
    historyEmptyHint: 'အန်သေးပစ်ပါ — ရလဒ်များ ဤနေရာတွင် ပေါ်လာမည်',
    historyRollTitle: 'လှိမ့်',
    timeJustNow: 'ယခုလေးတင်',
    timeMinAgo: '%n မိနစ်အကြာ',
    timeHourAgo: '%n နာရီအကြာ',
    timeDayAgo: '%n ရက်အကြာ',
    settingsDiceType: 'အန်သေးအမျိုးအစား',
    settingsCount: 'အန်သေး အရေအတွက်',
    settingsRollBtn: 'အန်သေးပစ် 🎲',
    settingsLanguage: 'ဘာသာစကား',
  },

  or: {
    tabRoll: 'ରୋଲ',
    tabHistory: 'ଇତିହାସ',
    tabSettings: 'ସେଟିଂ',
    headerRoll: 'ପଶା ରୋଲ',
    headerHistory: 'ରୋଲ ଇତିହାସ',
    headerSettings: 'ରୋଲ ସେଟିଂ',
    sumLabel: 'ମୋଟ:',
    rollBtn: 'ରୋଲ',
    rollBtnAria: 'ପୁଣି ରୋଲ କରନ୍ତୁ',
    clearHistory: 'ଇତିହାସ ସଫା କରନ୍ତୁ',
    historyEmpty: 'ଇତିହାସ ଖାଲି',
    historyEmptyHint: 'ପଶା ଫୋପଡ଼ନ୍ତୁ — ଫଳ ଏଠାରେ ଦେଖାଯିବ',
    historyRollTitle: 'ରୋଲ',
    timeJustNow: 'ଏଇଟ ବେଳ',
    timeMinAgo: '%n ମିନିଟ ଆଗ',
    timeHourAgo: '%n ଘଣ୍ଟା ଆଗ',
    timeDayAgo: '%n ଦିନ ଆଗ',
    settingsDiceType: 'ପଶା ପ୍ରକାର',
    settingsCount: 'ପଶାର ସଂଖ୍ୟା',
    settingsRollBtn: 'ପଶା ଫୋପଡ଼ 🎲',
    settingsLanguage: 'ଭାଷା',
  },

  th: {
    tabRoll: 'ทอย',
    tabHistory: 'ประวัติ',
    tabSettings: 'ตั้งค่า',
    headerRoll: 'ทอยลูกเต๋า',
    headerHistory: 'ประวัติการทอย',
    headerSettings: 'ตั้งค่าการทอย',
    sumLabel: 'รวม:',
    rollBtn: 'ทอย',
    rollBtnAria: 'ทอยอีกครั้ง',
    clearHistory: 'ล้างประวัติ',
    historyEmpty: 'ไม่มีประวัติ',
    historyEmptyHint: 'ทอยลูกเต๋า — ผลลัพธ์จะปรากฏที่นี่',
    historyRollTitle: 'ทอย',
    timeJustNow: 'เพิ่งเมื่อกี้',
    timeMinAgo: '%n นาทีที่แล้ว',
    timeHourAgo: '%n ชั่วโมงที่แล้ว',
    timeDayAgo: '%n วันที่แล้ว',
    settingsDiceType: 'ประเภทลูกเต๋า',
    settingsCount: 'จำนวนลูกเต๋า',
    settingsRollBtn: 'ทอยลูกเต๋า 🎲',
    settingsLanguage: 'ภาษา',
  },

  uk: {
    tabRoll: 'Кидок',
    tabHistory: 'Історія',
    tabSettings: 'Налаштування',
    headerRoll: 'Кидок кубиків',
    headerHistory: 'Історія кидків',
    headerSettings: 'Налаштування кидка',
    sumLabel: 'Сума:',
    rollBtn: 'Кинути',
    rollBtnAria: 'Кинути знову',
    clearHistory: 'Очистити історію',
    historyEmpty: 'Історія порожня',
    historyEmptyHint: "Кидайте кубики — результати з'являться тут",
    historyRollTitle: 'Кидок',
    timeJustNow: 'щойно',
    timeMinAgo: '%n хв. тому',
    timeHourAgo: '%n год. тому',
    timeDayAgo: '%n д. тому',
    settingsDiceType: 'Тип кубика',
    settingsCount: 'Кількість кубиків',
    settingsRollBtn: 'Кинути кубики 🎲',
    settingsLanguage: 'Мова',
  },

  am: {
    tabRoll: 'ወርወር',
    tabHistory: 'ታሪክ',
    tabSettings: 'ቅንብሮች',
    headerRoll: 'ዳይስ ወርወር',
    headerHistory: 'የወርወር ታሪክ',
    headerSettings: 'የወርወር ቅንብሮች',
    sumLabel: 'ድምር:',
    rollBtn: 'ወርወር',
    rollBtnAria: 'እንደገና ወርወር',
    clearHistory: 'ታሪክ አጽዳ',
    historyEmpty: 'ታሪክ ባዶ ነው',
    historyEmptyHint: 'ዳይስ ወርውሩ — ውጤቶቹ እዚህ ይታያሉ',
    historyRollTitle: 'ወርወር',
    timeJustNow: 'አሁን',
    timeMinAgo: 'ከ%n ደቂቃ በፊት',
    timeHourAgo: 'ከ%n ሰዓት በፊት',
    timeDayAgo: 'ከ%n ቀን በፊት',
    settingsDiceType: 'የዳይስ አይነት',
    settingsCount: 'የዳይስ ብዛት',
    settingsRollBtn: 'ዳይስ ወርወር 🎲',
    settingsLanguage: 'ቋንቋ',
  },

  nl: {
    tabRoll: 'Gooien',
    tabHistory: 'Geschiedenis',
    tabSettings: 'Instellingen',
    headerRoll: 'Dobbelstenen gooien',
    headerHistory: 'Gooi-geschiedenis',
    headerSettings: 'Gooi-instellingen',
    sumLabel: 'Totaal:',
    rollBtn: 'Gooi',
    rollBtnAria: 'Opnieuw gooien',
    clearHistory: 'Geschiedenis wissen',
    historyEmpty: 'Geschiedenis is leeg',
    historyEmptyHint: 'Gooi de dobbelstenen — resultaten verschijnen hier',
    historyRollTitle: 'Gooi',
    timeJustNow: 'zojuist',
    timeMinAgo: '%n min geleden',
    timeHourAgo: '%n u geleden',
    timeDayAgo: '%n d geleden',
    settingsDiceType: 'Dobbelsteentype',
    settingsCount: 'Aantal dobbelstenen',
    settingsRollBtn: 'Dobbelstenen gooien 🎲',
    settingsLanguage: 'Taal',
  },

  ro: {
    tabRoll: 'Aruncă',
    tabHistory: 'Istoric',
    tabSettings: 'Setări',
    headerRoll: 'Aruncare de zaruri',
    headerHistory: 'Istoricul aruncărilor',
    headerSettings: 'Setări de aruncare',
    sumLabel: 'Total:',
    rollBtn: 'Aruncă',
    rollBtnAria: 'Aruncă din nou',
    clearHistory: 'Șterge istoricul',
    historyEmpty: 'Istoricul este gol',
    historyEmptyHint: 'Aruncați zarurile — rezultatele vor apărea aici',
    historyRollTitle: 'Aruncare',
    timeJustNow: 'chiar acum',
    timeMinAgo: 'acum %n min',
    timeHourAgo: 'acum %n h',
    timeDayAgo: 'acum %n z',
    settingsDiceType: 'Tip de zar',
    settingsCount: 'Număr de zaruri',
    settingsRollBtn: 'Aruncați zarurile 🎲',
    settingsLanguage: 'Limbă',
  },

  az: {
    tabRoll: 'At',
    tabHistory: 'Tarix',
    tabSettings: 'Parametrlər',
    headerRoll: 'Zər atmaq',
    headerHistory: 'Atma tarixi',
    headerSettings: 'Atma parametrləri',
    sumLabel: 'Cəmi:',
    rollBtn: 'At',
    rollBtnAria: 'Yenidən at',
    clearHistory: 'Tarixi sil',
    historyEmpty: 'Tarix boşdur',
    historyEmptyHint: 'Zər atın — nəticələr burada görünəcək',
    historyRollTitle: 'Atma',
    timeJustNow: 'indi',
    timeMinAgo: '%n dəq. əvvəl',
    timeHourAgo: '%n saat əvvəl',
    timeDayAgo: '%n gün əvvəl',
    settingsDiceType: 'Zər növü',
    settingsCount: 'Zər sayı',
    settingsRollBtn: 'Zər at 🎲',
    settingsLanguage: 'Dil',
  },

  ms: {
    tabRoll: 'Golek',
    tabHistory: 'Sejarah',
    tabSettings: 'Tetapan',
    headerRoll: 'Golek Dadu',
    headerHistory: 'Sejarah Golek',
    headerSettings: 'Tetapan Golek',
    sumLabel: 'Jumlah:',
    rollBtn: 'Golek',
    rollBtnAria: 'Golek semula',
    clearHistory: 'Padam sejarah',
    historyEmpty: 'Sejarah kosong',
    historyEmptyHint: 'Golek dadu — keputusan akan muncul di sini',
    historyRollTitle: 'Golek',
    timeJustNow: 'baru sahaja',
    timeMinAgo: '%n min lalu',
    timeHourAgo: '%n jam lalu',
    timeDayAgo: '%n hari lalu',
    settingsDiceType: 'Jenis dadu',
    settingsCount: 'Bilangan dadu',
    settingsRollBtn: 'Golek dadu 🎲',
    settingsLanguage: 'Bahasa',
  },

  sw: {
    tabRoll: 'Tupa',
    tabHistory: 'Historia',
    tabSettings: 'Mipangilio',
    headerRoll: 'Kutupa Dadu',
    headerHistory: 'Historia ya Kutupa',
    headerSettings: 'Mipangilio ya Kutupa',
    sumLabel: 'Jumla:',
    rollBtn: 'Tupa',
    rollBtnAria: 'Tupa tena',
    clearHistory: 'Futa historia',
    historyEmpty: 'Historia ni tupu',
    historyEmptyHint: 'Tupa dadu — matokeo yataonekana hapa',
    historyRollTitle: 'Tupa',
    timeJustNow: 'sasa hivi',
    timeMinAgo: 'dakika %n zilizopita',
    timeHourAgo: 'saa %n zilizopita',
    timeDayAgo: 'siku %n zilizopita',
    settingsDiceType: 'Aina ya dadu',
    settingsCount: 'Idadi ya dadu',
    settingsRollBtn: 'Tupa dadu 🎲',
    settingsLanguage: 'Lugha',
  },

  el: {
    tabRoll: 'Ρίξε',
    tabHistory: 'Ιστορικό',
    tabSettings: 'Ρυθμίσεις',
    headerRoll: 'Ρίψη ζαριών',
    headerHistory: 'Ιστορικό ρίψεων',
    headerSettings: 'Ρυθμίσεις ρίψης',
    sumLabel: 'Σύνολο:',
    rollBtn: 'Ρίξε',
    rollBtnAria: 'Ρίξε ξανά',
    clearHistory: 'Διαγραφή ιστορικού',
    historyEmpty: 'Το ιστορικό είναι κενό',
    historyEmptyHint: 'Ρίξτε τα ζάρια — τα αποτελέσματα θα εμφανιστούν εδώ',
    historyRollTitle: 'Ρίψη',
    timeJustNow: 'μόλις τώρα',
    timeMinAgo: '%n λεπτά πριν',
    timeHourAgo: '%n ώρες πριν',
    timeDayAgo: '%n μέρες πριν',
    settingsDiceType: 'Τύπος ζαριού',
    settingsCount: 'Αριθμός ζαριών',
    settingsRollBtn: 'Ρίξτε τα ζάρια 🎲',
    settingsLanguage: 'Γλώσσα',
  },

  hu: {
    tabRoll: 'Dobás',
    tabHistory: 'Előzmények',
    tabSettings: 'Beállítások',
    headerRoll: 'Kockadobás',
    headerHistory: 'Dobás-előzmények',
    headerSettings: 'Dobásbeállítások',
    sumLabel: 'Összeg:',
    rollBtn: 'Dobj',
    rollBtnAria: 'Dobj újra',
    clearHistory: 'Előzmények törlése',
    historyEmpty: 'Nincsenek előzmények',
    historyEmptyHint: 'Dobj kockát — az eredmények itt fognak megjelenni',
    historyRollTitle: 'Dobás',
    timeJustNow: 'most',
    timeMinAgo: '%n perc',
    timeHourAgo: '%n óra',
    timeDayAgo: '%n nap',
    settingsDiceType: 'Kocka típusa',
    settingsCount: 'Kockák száma',
    settingsRollBtn: 'Dobj kockát 🎲',
    settingsLanguage: 'Nyelv',
  },

  zu: {
    tabRoll: 'Jikiza',
    tabHistory: 'Umlando',
    tabSettings: 'Izilungiselelo',
    headerRoll: 'Jikiza Idayisi',
    headerHistory: 'Umlando Wokujikiza',
    headerSettings: 'Izilungiselelo Zokujikiza',
    sumLabel: 'Isamba:',
    rollBtn: 'Jikiza',
    rollBtnAria: 'Jikiza futhi',
    clearHistory: 'Sula umlando',
    historyEmpty: 'Umlando awukho',
    historyEmptyHint: 'Jikiza idayisi — imiphumela izovela lapha',
    historyRollTitle: 'Ukujikiza',
    timeJustNow: 'manje',
    timeMinAgo: 'imizuzu %n edlule',
    timeHourAgo: 'amahora %n edlule',
    timeDayAgo: 'izinsuku %n ezedlule',
    settingsDiceType: 'Uhlobo lwedayisi',
    settingsCount: 'Inombolo yamadayisi',
    settingsRollBtn: 'Jikiza idayisi 🎲',
    settingsLanguage: 'Ulimi',
  },

  cs: {
    tabRoll: 'Hodit',
    tabHistory: 'Historie',
    tabSettings: 'Nastavení',
    headerRoll: 'Hod kostkou',
    headerHistory: 'Historie hodů',
    headerSettings: 'Nastavení hodu',
    sumLabel: 'Součet:',
    rollBtn: 'Hodit',
    rollBtnAria: 'Hodit znovu',
    clearHistory: 'Vymazat historii',
    historyEmpty: 'Historie je prázdná',
    historyEmptyHint: 'Hoďte kostkou — výsledky se zobrazí zde',
    historyRollTitle: 'Hod',
    timeJustNow: 'právě teď',
    timeMinAgo: 'před %n min',
    timeHourAgo: 'před %n hod',
    timeDayAgo: 'před %n d',
    settingsDiceType: 'Typ kostky',
    settingsCount: 'Počet kostek',
    settingsRollBtn: 'Hodit kostkou 🎲',
    settingsLanguage: 'Jazyk',
  },

  sv: {
    tabRoll: 'Kasta',
    tabHistory: 'Historik',
    tabSettings: 'Inställningar',
    headerRoll: 'Tärningskast',
    headerHistory: 'Kasthistorik',
    headerSettings: 'Kastinställningar',
    sumLabel: 'Summa:',
    rollBtn: 'Kasta',
    rollBtnAria: 'Kasta igen',
    clearHistory: 'Rensa historik',
    historyEmpty: 'Historiken är tom',
    historyEmptyHint: 'Kasta tärning — resultaten visas här',
    historyRollTitle: 'Kast',
    timeJustNow: 'nyss',
    timeMinAgo: 'för %n min sedan',
    timeHourAgo: 'för %n tim sedan',
    timeDayAgo: 'för %n d sedan',
    settingsDiceType: 'Tärningstyp',
    settingsCount: 'Antal tärningar',
    settingsRollBtn: 'Kasta tärning 🎲',
    settingsLanguage: 'Språk',
  },

  xh: {
    tabRoll: 'Phosa',
    tabHistory: 'Imbali',
    tabSettings: 'Izisetho',
    headerRoll: 'Phosa iDayisi',
    headerHistory: 'Imbali Yokuphosa',
    headerSettings: 'Izisetho Zokuphosa',
    sumLabel: 'Isishwankathelo:',
    rollBtn: 'Phosa',
    rollBtnAria: 'Phosa futhi',
    clearHistory: 'Cima imbali',
    historyEmpty: 'Akukho mbali',
    historyEmptyHint: 'Phosa idayisi — iziphumo ziya kubonakala apha',
    historyRollTitle: 'Ukuphosa',
    timeJustNow: 'ngoku',
    timeMinAgo: 'imizuzu %n eyadlulayo',
    timeHourAgo: 'iiyure %n eyadlulayo',
    timeDayAgo: 'iintsuku %n eyadlulayo',
    settingsDiceType: 'Uhlobo lwedayisi',
    settingsCount: 'Inani ledayisi',
    settingsRollBtn: 'Phosa idayisi 🎲',
    settingsLanguage: 'Ulwimi',
  },
};
